/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiAPlayForwardIcon16Light } from './MediaUiAPlayForwardIcon16Light';
import { MediaUiAPlayForwardIcon16Regular } from './MediaUiAPlayForwardIcon16Regular';
import { MediaUiAPlayForwardIcon16Solid } from './MediaUiAPlayForwardIcon16Solid';
import { MediaUiAPlayForwardIcon20Light } from './MediaUiAPlayForwardIcon20Light';
import { MediaUiAPlayForwardIcon20Regular } from './MediaUiAPlayForwardIcon20Regular';
import { MediaUiAPlayForwardIcon20Solid } from './MediaUiAPlayForwardIcon20Solid';
import { MediaUiAPlayForwardIcon24Regular } from './MediaUiAPlayForwardIcon24Regular';
import { MediaUiAPlayForwardIcon24Solid } from './MediaUiAPlayForwardIcon24Solid';
import { MediaUiAPlayForwardIcon32Regular } from './MediaUiAPlayForwardIcon32Regular';
import { MediaUiAPlayForwardIcon64Regular } from './MediaUiAPlayForwardIcon64Regular';
var sizes = {
    16: {
        light: MediaUiAPlayForwardIcon16Light,
        regular: MediaUiAPlayForwardIcon16Regular,
        solid: MediaUiAPlayForwardIcon16Solid,
    },
    20: {
        light: MediaUiAPlayForwardIcon20Light,
        regular: MediaUiAPlayForwardIcon20Regular,
        solid: MediaUiAPlayForwardIcon20Solid,
    },
    24: {
        regular: MediaUiAPlayForwardIcon24Regular,
        solid: MediaUiAPlayForwardIcon24Solid,
    },
    32: {
        regular: MediaUiAPlayForwardIcon32Regular,
    },
    64: {
        regular: MediaUiAPlayForwardIcon64Regular,
    },
};
export var MediaUiAPlayForwardIcon = forwardRef('MediaUiAPlayForwardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
